import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { OrderItem } from "@/interfaces/domain/Order";
import { StoreHighlight } from "@/interfaces/domain/StoreHighlight";
import {
  getStoreHighlightByIdRequest,
  getStoreHighlightsRequest,
} from "@/services/api/storeHighlights";
import { logger } from "@/services/logger";
import { formatProductToOrderItem } from "@/utils/helpers";

export const useStoreHighlight = (storeId: string, options?: UseQueryOptions<StoreHighlight[]>) => {
  return useQuery<StoreHighlight[]>({
    queryKey: [`/store-highlights/${storeId}`],
    queryFn: () => getStoreHighlightsRequest(storeId),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });
};

export const useStoreHighlightById = (id: string, options?: UseQueryOptions<StoreHighlight>) => {
  const { data, ...rest } = useQuery<StoreHighlight>({
    queryKey: [`/highlight/${id}`],
    queryFn: () => getStoreHighlightByIdRequest(id),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });

  return {
    data: data
      ? ({
          ...data,
          produtos: data?.produtos?.map(formatProductToOrderItem),
        } as StoreHighlight<OrderItem[]>)
      : null,
    ...rest,
  };
};
